// import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";

import Footer from "../../common/components/Footer";
import Nav from "../../common/components/Nav";
import { fetchPublicPagesByType } from "../../utils/api/cms/page";
import { errorHandler } from "../../utils/helpers/errorHandler";
import { Link } from "react-router-dom";

const token = JSON.parse(localStorage.getItem("eko-360-p2-token"));
const rootUrl = `${process.env.REACT_APP_ROOT_URL}`;

const QuickReadPage = () => {
  const [publicPages, setPublicPages] = useState([]);
  const [publicQuickReads, setPublicQuickReads] = useState([]);
  const [quickReads, setQuickReads] = useState([]);

  const handleFetchPublicQuickReads = async (page = 0) => {
    try {
      const data = await fetchPublicPagesByType(page, "quick_reads");

      setPublicQuickReads(data.data.allPages);
    } catch (error) {
      errorHandler(error, toast);
    }
  };

  useEffect(() => {
    handleFetchPublicQuickReads();
  }, []);

  useEffect(() => {
    if (publicQuickReads) {
      const quickReads = publicQuickReads.filter((pages) => pages.type === "quick_reads");

      setQuickReads(quickReads);
    }
  }, [publicQuickReads]);

  return (
    <div>
      <header>
        <Nav />
      </header>

      <section>
        <div className="container">
          <div
            className="__all-banner"
            style={{ background: `url(/assets/img/pagesbanner.png)` }}
          >
            <p className="__caption-banner text-center">Quick Reads</p>
          </div>
        </div>

        <div
          className="__datasetbg"
          style={{ background: `url(/assets/img/latestbg.png)` }}
        >
          {quickReads.length > 0 && (
            <div className="container">
              {/* <div className="__quipdiv">
                <p className="__latst1">
                  This is an interactive dashboard that visualizes different
                  analysis and insights on various Lagos State data across
                  health, education and economic affairs sectors.
                </p>
              </div> */}
              <div className="row">
                  {quickReads.length > 0
                    ? quickReads.map((quickRead) => (
                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div
                            className="__quicimg"
                            style={{ background: `url(${process.env.REACT_APP_ROOT_URL}/uploads/${quickRead?.banner})` }}
                          ></div>
                          <div className="__quicdiv">
                            <p
                              className="__quicp2 __higt"
                              style={{ textTransform: "uppercase" }}
                            >
                              {quickRead.title}
                            </p>
                            {quickRead.body.length > 150 ? (
                              <p className="__quicp3">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: `${quickRead.body.substr(0, 200)}...`,
                                  }}
                                ></div>
                              </p>
                            ) : (
                              <p className="__quicp3">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: quickRead.body,
                                  }}
                                ></div>
                              </p>
                            )}
                            <Link
                              to={`/pages/${quickRead.slug}`}
                              className="btn btn-block hvr-float-shadow __quicbtn"
                            >
                              Read Now
                            </Link>
                          </div>
                        </div>
                      ))
                    : null}
                </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default QuickReadPage;
